import React from 'react';
import { connect } from 'react-redux';
import MaterialDrawer from 'material-ui/Drawer';
import styles from './styles.scss';

class Drawer extends React.Component {
  componentWillReceiveProps(newProps) {
    if (newProps.drawerOpen !== this.props.drawerOpen) {
      const $wrapper = document.querySelector('#content-wrapper');
      if (newProps.drawerOpen) {
        $wrapper.classList.add('drawer-open');
      } else {
        $wrapper.classList.remove('drawer-open');
      }
    }
  }

  render() {
    const settings = this.props.drawerSettings;
    return (
      <div>
        <MaterialDrawer open={this.props.drawerOpen} className={styles.drawer}>
          {!!settings.component &&
            React.createElement(settings.component, {
              ...this.props
            })}
        </MaterialDrawer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    drawerOpen: state.drawer.open,
    drawerSettings: state.drawer.settings
  };
}

export default connect(mapStateToProps)(Drawer);



// WEBPACK FOOTER //
// ./src/components/util/drawer/index.js